type ClassValue = string | false | null | undefined;

/** Concatene des classes utilitaires en ignorant ce qui est vide. */
export function cn(...values: ClassValue[]): string {
  return values.filter((value): value is string => Boolean(value)).join(" ");
}
